export default "__VITE_ASSET__387df22d__"